<template>
    <div class="m-details scene"
         v-if="displayed"
         v-bind:class="{ '--pause': openDetail}"
         v-on:click="close()">
        <div class="m-details__wrapper"
             v-bind:class="{'scrolled': scrollMax, 'hide' : arrowVisible}">
            <div class="m-details__wrapperTexts">
                <div class="m-details__progress">
                <span class="a-progress_bar">
                <span class="a-progress__inner" v-bind:style="{
                  height: progressW + '%',
                  background: startColor,
                }"></span>
                </span>
                </div>
                <div class="m-details__content scrollable" ref="mcontent">
                    <div class="a-details__scroll"
                         v-scroll="onScroll"
                         ref="scrollContainer"
                            v-bind:style="{ overflow: isOverflow}">
                        <div class="a-details__scrollh" ref="scrollContainerH" >
                            <div>
                                <span class="a-details__channel" ref="achannel">
                                    à la une
                                </span>
                                <h1 class="a-details__title">{{ displayed.title }}</h1>
                                <span class="a-details__infos" ref="ainfos">
                                    <span class="a-details__place">
                                    {{ displayed.country }}, {{ displayed.city }}
                                    </span>
                                    <span class="a-details__time">
                                        {{ displayed.getDate() }}
                                    </span>
                                </span>
                            </div>
                            <div class="m-details__contentText" ref="mcontentText">
                                <p v-for="(texte, index) in displayed.content"
                                   v-bind:key="index"
                                   v-html='showText(texte)'>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="m-details__image"
                 v-on:click="close()"
                 ref="imgContent">
                <img class="scene" :src="displayed.getLargeHref()" alt="">
            </div>
            <div class="m-details__bonus">
                <div class="a-details__tags"
                     v-bind:class="{'show': showTag }"
                     v-bind:style="{
                      height: progressW + '%',
                      color: startColor,
                    }">
                  <strong>Explore un fil</strong>
                    <ul>
                        <li v-for="(slug, index) in slugs"
                            v-on:mouseover="hovered = index"
                            v-on:mouseleave="hovered = false"
                            v-bind:key="index"
                            v-on:click="goSlug(slug)"
                            v-bind:style="hoverStyle(index)"
                            class="m-slugs__slug">
                              {{ slug }} {{ hovered[index] }}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
      <div class="m-details__bkg1 scene"
           v-bind:style="{backgroundImage : 'url('+urlBkgB1+')'}"
           ref="bkg1"
           v-on:click="close()">
      </div>
      <div class="m-details__bkg2 scene"
           ref="bkg2"
           v-bind:style="{backgroundImage : 'url('+urlBkgB2+')'}"
           v-on:click="close()">
      </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import vuescroll from 'vue-scroll';
import { TimelineLite, Power2 } from 'gsap';
import Vue from 'vue';
import Sequence from '@/models/Sequence';
import arrowSVG from '../../assets/images/arrowbot.svg';
import srcBkgB1 from '../../assets/images/textureB1.png';
import srcBkgB2 from '../../assets/images/textureB2.png';

Vue.use(vuescroll);
export default {
  name: 'viewer',
  components: {
  },
  data() {
    return {
      hovered: [],
      scrolled: false,
      scrollPosition: 0,
      scrollMax: 0,
      showTag: false,
      arrowVisible: false,
      progressW: 1,
      displayed: new Sequence(),
      urlArrowSvg: arrowSVG,
      urlBkgB1: srcBkgB1,
      urlBkgB2: srcBkgB2,
      openDetail: false,
      timeline: null,
      timelineScroll: null,
      lock: false,
      isOverflow: 'auto',
      nbParagraphShow: 3,
      nbParagraph: 0,
    };
  },
  computed: {
    ...mapGetters([
      'startColor',
      'isPlaying',
      'isDetail',
      'displayedSequence',
      'currentSlug',
    ]),
    slugs() {
      return this.displayed.slugs.filter(s => s !== this.currentSlug).slice(0, 3);
    },
  },
  methods: {
    ...mapMutations([
      'play',
      'closeDetail',
    ]),
    ...mapActions([
      'getChannelById',
      'playChannel',
      'playSlug',
      'updateSlug',
    ]),
    close() {
      this.closeAnimation().then(() => this.closeDetail());
    },
    hoverStyle(index) {
      return this.hovered === index ? {
        background: this.startColor,
        color: 'white',
        border: `1px solid ${this.startColor}`,
      } : {};
    },
    goSlug(slug) {
      if (slug !== this.currentSlug) {
        this.closeAnimation()
          .then(() => this.updateSlug(slug))
          .then(() => this.closeDetail());
      }
    },
    onScroll(e, position) {
      this.scrollPosition = position.scrollTop;
      // const top = position.scrollTop;
      const topOffset = position.scrollTop + 400;
      const mid = this.$refs.scrollContainerH.offsetHeight;
      const max = this.$refs.scrollContainerH.clientHeight - 700;
      this.progressW = ((topOffset * 100) / mid) * 1.5; // TODO animation
      this.scrollMax = topOffset >= max;

      if (topOffset < mid) {
        this.scrolled = false;
      } else {
        this.scrolled = true;
      }
      if (this.scrollMax) {
        this.showTag = true;
        this.progressW = 100;
      } else {
        this.showTag = false;
      }
    },
    startAnimation() {
      this.timeline.clear();

      /* this.timeline.to(this.$refs.bkg2, 0.4, {
        opacity: 1,
      }, '-=0.4'); */
      this.timeline.to(this.$refs.bkg1, 0.01, {
        bottom: '-100vh',
        ease: Power2.easeOut,
      });
      this.timeline.to(this.$refs.imgContent, 0.1, {
        left: -585,
        width: '100%',
        ease: Power2.easeInOut,
      });
      this.timeline.to(this.$refs.bkg2, 0.5, {
        bottom: '-50vh',
        ease: Power2.easeOut,
      });
      this.timeline.to(this.$refs.achannel, 0.6, {
        left: 0,
        opacity: 1,
        ease: Power2.easeOut,
      });
      this.timeline.to(this.$refs.ainfos, 0.6, {
        left: 0,
        opacity: 1,
        ease: Power2.easeOut,
      }, '-=0.6');
      this.timeline.to(this.$refs.mcontentText, 0.8, {
        left: 0,
        opacity: 1,
        ease: Power2.easeOut,
      }, '-=0.1');
    },
    showText(texte) {
      let texteresult = texte;
      if (texte.indexOf('http://') === 0 || texte.indexOf('https://') === 0) {
        texteresult = `<a href='${texte}' style='color: #4970b8;text-decoration: none;'/>lien</a>`;
      }
      return texteresult;
    },
    closeAnimation() {
      return new Promise((resolve) => {
        this.showTag = false;
        this.timeline.to(this.$refs.imgContent, 0.1, {
          left: 0,
          ease: Power2.easeOut,
        });
        this.timeline.to(this.$refs.bkg1, 0.2, {
          left: '20px',
          ease: Power2.easeOut,
        });
        this.timeline.to(this.$refs.bkg2, 0.2, {
          left: 150,
          width: '30vw',
          ease: Power2.easeInOut,
        });
        this.timeline.to(this, 0.2, {
          onComplete: () => {
            this.openDetail = false;
            this.$refs.scrollContainer.scrollTop = 0;
            this.scrollPosition = 0;
            resolve();
          },
        });
      });
    },
  },
  watch: {
    isDetail(isDetail) {
      if (isDetail) {
        this.displayed = this.displayedSequence;
        this.openDetail = true;
        if (this.displayedSequence.content.length < 3 && this.displayed.content.length !== 0) {
          this.showTag = true;
          this.arrowVisible = true;
          this.progressW = 100;
        } else {
          this.showTag = false;
          this.arrowVisible = false;
          this.progressW = 1;
        }
        this.nbParagraph = this.displayed.content.length;
        if (this.timeline === null) {
          this.timeline = new TimelineLite({
            pause: true,
            autoRemoveChildren: true,
            useFrames: false,
          });
        }
        setTimeout(() => {
          this.startAnimation();
        }, 800);
      } else {
        this.timeline.set(this.$refs.bkg2, { clearProps: 'opacity, bottom, left, width' });
        this.timeline.set(this.$refs.bkg1, { clearProps: 'bottom, left' });
        this.timeline.set(this.$refs.imgContent, { clearProps: 'left' });
        this.timeline.set(this.$refs.achannel, { clearProps: 'opacity, left' });
        this.timeline.set(this.$refs.ainfos, { clearProps: 'opacity, left' });
        this.timeline.set(this.$refs.mcontentText, { clearProps: 'opacity, left' });
        this.timeline.set(this.$refs.aarrow, { clearProps: 'opacity, bottom' });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .m-details {
    font-family: Sailec, sans-serif;
    background-color: transparent;
    cursor: none;
    position: absolute;
    top: 100%;
    bottom: -100%;
    left: 0;
    right: 0;
    transition: 0.4s ease-in-out all;
    opacity: 0;

    &.--pause {
      top: 0;
      bottom: 0;
      opacity: 1;
      transition: 0.4s all;
    }
    &__wrapper {
      margin-top: 9vh;
      background-color: white;
      height: 100vh;
      z-index: 1;
      position: absolute;
      left: 60%;
      width: 930px;
      cursor: auto;
      transform: translateX(-50%);

      @media screen and (max-width: 1620px) {
        width: 757px;
      }
    }

    &__wrapperTexts {
      position: relative;
      transition: 1.8s ease;
      bottom: 0;
      &.animeGoBot {
        bottom: -150vh;
      }
    }

    &__image {
      position: absolute;
      z-index: -1;
      top: 75px;
      left: 0px;
      transition: 1s ease;
      cursor: none;
      overflow: hidden;
      width: 0;

      img {
        height: 510px;
        position: relative;
        bottom: 0;
        left: 0;
        transition: 1s ease;
        &.animeGoLeft {
          left: -2000px;
        }

        @media screen and (max-width: 1770px) {
          height: 540px;
          left: 7vw;
        }

        @media screen and (max-width: 1450px) {
          height: 390px;
          left: 12vw;
        }

        @media screen and (max-width: 1360px) {
          height: 360px;
          left: 12vw;
        }
      }
    }

    &__progress {
      height: 64vh;
      position: absolute;
      right: 0px;
      top: 0px;
      z-index: 2;
      @media screen and (max-width: 1450px) {
        height: 56vh;
      }

      .a-progress_bar {
        width: 4px;
        height: 100%;
        background-color: #fff;
        display: block;
        overflow: hidden;
      }
      .a-progress__inner {
        background-color: #406eb9;
        height: 4%;
        display: block;
        width: 100%;
        transition: .3s linear;
      }
    }

    &__content {
      // margin-top: 70px;
      // padding: 0 102px;
      padding-top: 70px;
      position: relative;
      background-color: #fff;
      // left: 11%;

      &:after {
        content: '';
        position: absolute;
        background: linear-gradient(to bottom, rgba(255, 255, 255, 0), #fff);
        width: 100%;
        height: 180px;
        bottom: 0;
        left: 0;
        pointer-events: none;
      }

      a {
        color: #4970b8;
        text-transform: none;
      }
    }

    &__contentText {
      position: relative;
      opacity: 0;
      left: -30px;
      padding-top: 60px;
      padding-bottom: 100px;
      p {
        font-family: 'Sailec';
        opacity: 1;
        position: relative;
        font-weight: 900;
        padding-right: 29px;
        line-height: 28px;
        font-size: 18px;
        margin-bottom: 40px;
        position: relative;
        transition: .5s ease-out;
        bottom: 0;
        &.hidden {
          opacity: 0;
          bottom: -100px;
        }
        @media screen and (max-width: 1620px) {
          font-size: 16px;
        }
      }
    }

    &__bonus {
      position: absolute;
      transition: 1.8s ease;
      top: 66vh;
      right: 0px;
      &.animeGoBot {
        bottom: -300px;
      }
    }

    &__bkg1 {
      opacity: 0.001;
      width: 41vw;
      height: 86vh;
      display: block;
      position: absolute;
      background-size: cover;
      z-index: -1;
      transition: 1s ease;
      bottom: -200vh;
      left: -40vw;
      cursor: none;
    }

    &__bkg2 {
      width: 30vw;
      height: 86vh;
      display: block;
      position: absolute;
      right: -20vw;
      bottom: 30vh;
      background-size: cover;
      z-index: -1;
      opacity: 0.001;
      cursor: none;
    }

    .a-details {
      &__scroll {
        overflow-y: auto;
        height: 75vh;
        padding: 0 117px;
        &::-webkit-scrollbar {
          display: none;
        }
      }
      &__scrollh {
        position: relative;
      }
      &__channel {
        text-transform: uppercase;
        // border-top: 1px solid #000;
        border-bottom: 1px solid #000;
        display: inline-block;
        padding: 10px 0px;
        margin-bottom: 100px;
        font-family: TrioGrotesk, sans-serif;
        font-weight: 600;
        position: relative;
        opacity: 0;
        left: -30px;
      }
      &__title {
        font-size: 52px;
        margin: 0;
        padding: 0;
        padding-bottom: 30px;
        font-weight: 100;
        line-height: 60px;
        @media screen and (max-width: 1620px) {
          font-size: 42px;
        }
      }
      &__place, &__time {
        color: #b9b9ba;
        text-transform: uppercase;
        font-size: 13px;
        margin-bottom: 58px;
      }
      &__infos {
        position: relative;
        opacity: 0;
        left: -30px;
        font-family: 'TrioGrotesk';
      }
      &__place {
        padding-right: 39px;
        border-right: 1px solid #b9b9ba;
      }
      &__time {
        margin-left: 39px;
      }
      &__tags {
        font-family: TrioGrotesk, sans-serif;
        position: relative;
        right: -180px;
        opacity: 0;
        transition: .5s ease-out;
        font-size: 14px;

        &.show {
          opacity: 1;
          right: -155px;
        }
        strong {
          text-transform: uppercase;
          font-size: 14px;
          padding-bottom: 29px;
          display: block;
          font-weight: 300;
        }
        ul {
          list-style: none;
          text-transform: uppercase;
          padding: 0;
          margin: 0;

          li {
            transition: .1s ease;
            border: 1px solid;
            padding: 15px 20px;
            width: auto;
            display: table;
            position: relative;
            bottom: 1px;
            cursor: pointer;

            @media screen and (max-width: 1450px) {
              font-size: 14px;
            }

            @media screen and (max-width: 1200px) {
              font-size: 13px;
            }

            &:last-child {
              margin-bottom: 0;
              position: relative;
              bottom: 2px;
            }
            &:first-child {
              margin-bottom: 0;
              position: relative;
              bottom: 0px;
            }
            &:hover {
              background-color: #406db9;
              color: #fff;
            }
          }
        }
      }
      &__arrow {
        position: absolute;
        bottom: 0px;
        right: 30px;
        transition: .5s ease;
        opacity: 0;
        img {
          height: 25px;
        }
        &.scrolled {
          transform: rotate(180deg);
        }
        &.hide {
          opacity: 0;
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/Player/Details.vue